import { apiRequest, investmentEntityRequest } from '@utils/request';
import { ExistingUserWaitlistRequest, NewUserWaitlistRequest, WaitlistQuestion } from 'types/waitlist';
import { SignupFlowType } from 'types/checkout';

export const getWaitlistQuestions = async (
	offeringId: string,
	signupFlowType: SignupFlowType
): Promise<Array<WaitlistQuestion>> => {
	const res = await apiRequest.get(`/waitlist-questions?offeringId=${offeringId}&signupFlowType=${signupFlowType}`);
	return res.data;
};

export const submitNewUserWaitlistResponses = async (responses: NewUserWaitlistRequest): Promise<void> => {
	await apiRequest.post(`/waitlist/new-user-responses`, responses);
};

export const submitExistingUserWaitlistResponses = async (responses: ExistingUserWaitlistRequest): Promise<void> => {
	await investmentEntityRequest.post(`/waitlist/existing-user-responses`, responses);
};
